export default __webpack_public_path__ + "static/CircularStd-Book-7de207033c507e08ad1afbf471d15bc2.ttf";